// DEV-02 ① / ③ 的 QR（provisioning §4.6、§5.1）。內容含 Wi-Fi 密碼 / 配對碼：只畫、不 log、不存。
import { useMemo } from 'react';
import qrcode from 'qrcode-generator';
import { utf8Binary } from './pairQr';

export function PairQrCode({ text, label }: { text: string; label: string }) {
  const svg = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(utf8Binary(text), 'Byte'); // UTF-8 byte mode（中文 SSID 原樣）
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 4, scalable: true });
  }, [text]);
  // qrcode-generator 產生的 SVG 只含矩形，沒有使用者輸入的 HTML
  return <div className="pair-qr" role="img" aria-label={label} data-pair-qr dangerouslySetInnerHTML={{ __html: svg }} />;
}
